"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.organizationOperationsSearchResponseSchema = exports.organizationOperationsSearchItemSchema = exports.organizationOperationsSearchQuerySchema = exports.organizationOperationsOverviewResponseSchema = exports.organizationLocationOperationsMetricSchema = exports.organizationOperationalScopeSchema = exports.organizationOperationsOverviewQuerySchema = void 0;
const zod_1 = require("zod");
const business_1 = require("./business");
const organizationOperationsRangeFields = {
    from: zod_1.z.string().datetime(),
    to: zod_1.z.string().datetime(),
};
const organizationOperationsRangeSchema = zod_1.z
    .object(organizationOperationsRangeFields)
    .superRefine((value, context) => {
    const from = Date.parse(value.from);
    const to = Date.parse(value.to);
    if (to <= from) {
        context.addIssue({
            code: "custom",
            path: ["to"],
            message: "The end of the range must be after the start.",
        });
    }
    if (to - from > 93 * 24 * 60 * 60 * 1_000) {
        context.addIssue({
            code: "custom",
            path: ["to"],
            message: "Organization reporting ranges cannot exceed 93 days.",
        });
    }
});
exports.organizationOperationsOverviewQuerySchema = organizationOperationsRangeSchema;
exports.organizationOperationalScopeSchema = zod_1.z.object({
    organizationId: zod_1.z.string().uuid(),
    tenantId: zod_1.z.string().uuid(),
    tenantName: zod_1.z.string().min(1).max(120),
    businessId: zod_1.z.string().uuid(),
    businessName: zod_1.z.string().min(1).max(120),
    locationId: business_1.operationalLocationIdSchema,
    locationName: zod_1.z.string().min(1).max(120),
    timezone: zod_1.z.string().min(1).max(64),
    role: business_1.membershipRoleSchema,
    canReportFinancials: zod_1.z.boolean(),
});
exports.organizationLocationOperationsMetricSchema = zod_1.z.object({
    scope: exports.organizationOperationalScopeSchema,
    openJobCount: zod_1.z.number().int().nonnegative(),
    scheduledAppointmentCount: zod_1.z.number().int().nonnegative(),
    unscheduledJobCount: zod_1.z.number().int().nonnegative(),
    completedJobCount: zod_1.z.number().int().nonnegative(),
    operationalRevenueCents: zod_1.z.number().int().nonnegative().nullable(),
});
exports.organizationOperationsOverviewResponseSchema = zod_1.z.object({
    organization: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        displayName: zod_1.z.string().min(1).max(120),
    }),
    range: zod_1.z.object({
        from: zod_1.z.string().datetime(),
        to: zod_1.z.string().datetime(),
    }),
    customerCount: zod_1.z.number().int().nonnegative(),
    locationCount: zod_1.z.number().int().nonnegative(),
    metrics: zod_1.z.array(exports.organizationLocationOperationsMetricSchema),
    totals: zod_1.z.object({
        openJobCount: zod_1.z.number().int().nonnegative(),
        scheduledAppointmentCount: zod_1.z.number().int().nonnegative(),
        unscheduledJobCount: zod_1.z.number().int().nonnegative(),
        completedJobCount: zod_1.z.number().int().nonnegative(),
        operationalRevenueCents: zod_1.z.number().int().nonnegative(),
        financialLocationCount: zod_1.z.number().int().nonnegative(),
    }),
});
exports.organizationOperationsSearchQuerySchema = zod_1.z.object({
    query: zod_1.z.string().trim().min(2).max(120),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(25),
});
const organizationOperationsSearchIdentity = zod_1.z.object({
    organizationId: zod_1.z.string().uuid(),
    tenantId: zod_1.z.string().uuid(),
    tenantName: zod_1.z.string().min(1).max(120),
    businessId: zod_1.z.string().uuid(),
    businessName: zod_1.z.string().min(1).max(120),
});
exports.organizationOperationsSearchItemSchema = zod_1.z.discriminatedUnion("kind", [
    organizationOperationsSearchIdentity.extend({
        kind: zod_1.z.literal("CUSTOMER"),
        id: zod_1.z.string().uuid(),
        label: zod_1.z.string().min(1),
        detail: zod_1.z.string().nullable(),
        ownership: zod_1.z.literal("TENANT_SHARED"),
        location: zod_1.z.null(),
    }),
    organizationOperationsSearchIdentity.extend({
        kind: zod_1.z.literal("JOB"),
        id: zod_1.z.string().uuid(),
        label: zod_1.z.string().min(1),
        detail: zod_1.z.string().nullable(),
        ownership: zod_1.z.literal("OPERATIONAL_LOCATION"),
        location: zod_1.z.object({
            id: business_1.operationalLocationIdSchema,
            name: zod_1.z.string().min(1).max(120),
        }),
    }),
]);
exports.organizationOperationsSearchResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.organizationOperationsSearchItemSchema),
    total: zod_1.z.number().int().nonnegative(),
    truncated: zod_1.z.boolean(),
});
//# sourceMappingURL=organization-operations.js.map